<template>
  <div class="sellCenter container storeBuyOrder">
    <!-- 过滤条件start -->
    <div ref="headerBtn" class="headerBtn">
      <!-- 顶部按钮start -->
      <div class="tabsBox">
        <el-tabs type="card" @tab-click="handleChangeType">
          <el-tab-pane label="全部订单"> </el-tab-pane>
          <el-tab-pane label="待付款"> </el-tab-pane>
          <el-tab-pane label="待发货"> </el-tab-pane>
          <el-tab-pane label="已发货"> </el-tab-pane>
          <el-tab-pane label="待评价"> </el-tab-pane>
          <el-tab-pane label="退款"> </el-tab-pane>
          <el-tab-pane label="已完成"> </el-tab-pane>
        </el-tabs>
        <div class="afterBox"></div>
      </div>
      <!-- 顶部按钮end -->
    </div>
    <!-- 过滤条件end -->
    <div>
      <el-table
        :data="list"
        border
        highlight-current-row
        v-loading="loading"
        :height="tabHeight"
        size="mini"
        @selection-change="handleSelectionChange"
        :style="{ 'background-color': 'transparent' }"
        :header-cell-style="{ 'background-color': '#f8f8f8' }"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="goodsDetailBox">
              <div v-for="(item, index) in scope.row.products" :key="index">
                <div class="goodsDetailItem">
                  <el-image
                    fit="cover"
                    class="goodsDetailItemImg textHover"
                    @click="() => checkImgAtTable(item)"
                    :data-src="getImageUrl(item.imgurl)"
                    :src="getImageUrl(item.imgurl)"
                  ></el-image>
                  <div class="goodsDetailItemText">
                    商品名称:{{ item.p_name }}
                  </div>
                  <div class="goodsDetailItemText">分类:{{ item.breed }}</div>
                  <div class="goodsDetailItemText">
                    单价:{{ item.price }}/{{ item.unit }}
                  </div>
                  <div class="goodsDetailItemText">
                    购买数量:{{ item.number }}{{ item.buyUnit }}
                  </div>
                  <div class="goodsDetailItemText" v-if="item.totalWeight">
                    总重:{{ item.totalWeight }}kg
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column
          width="200"
          show-overflow-tooltip
          align="center"
          label="操作"
        >
          <div slot-scope="scope">
            <el-button
              v-if="scope.row.o_status == 1"
              class="_mini"
              @click="
                () => {
                  toPay(scope.row);
                }
              "
              type="info"
              size="mini"
              >立即付款</el-button
            >

            <el-button
              v-else-if="scope.row.o_status == 3"
              class="_mini"
              type="info"
              size="mini"
              @click="()=>haveGetGoods(scope.row)"
              >确认收货</el-button
            >
          <el-button
              v-else-if="(scope.row.o_status == 4)&&scope.row.payTime"
              class="_mini"
              type="info"
              size="mini"
              @click="()=>downloaindPdf(scope.row)"
              >电子回单</el-button
            >
  <el-button
              v-else-if="(scope.row.o_status == 5)&&scope.row.payTime"
              class="_mini"
              type="info"
              size="mini"
              @click="()=>downloaindPdf(scope.row)"
              >电子回单</el-button
            >


            <el-button
              v-else-if="
                [ 6, 7, 8, 10, 11].some((item) => {
                  return item == scope.row.o_status;
                })
              "
              class="_mini"
              @click="() => ensureDeleteOrder(scope.row)"
              type="info"
              size="mini"
              >删除订单</el-button
            >


            <div v-else>
              -
            </div>
          
          </div>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="订单类型"
          width="100"
        >
          <div class="green">采购订单</div>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="store_name"
          label="卖家店铺"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="number"
          label="数量"
          width="100"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.products && scope.row.products[0]">
              {{
                scope.row.products.some((item) => {
                  return item.breed.indexOf("白条") > -1;
                })
                  ? scope.row.totalWeight + scope.row.products[0].unit
                  : scope.row.number + (scope.row.products[0].unit || "件")
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="商品总价(元)"
          width="130"
        >
          <template slot-scope="scope">
            <div class="red">
              {{ formateTotalMoney(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="100"
          prop="order_id"
          label="订单编号"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="o_status"
          label="订单状态"
        >
          <template slot-scope="scope">
            <div :class="renderStatusClass(scope.row)">
              {{ formatteStatus(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          label="下单时间"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.createTime | formateDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="take_name"
          label="收货人名称"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="phone"
          label="收货人电话"
        >
        </el-table-column>
      </el-table>
      <!-- 分页start -->
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="total,  prev, pager, next, jumper"
          :total="total || 0"
          :page-size="15"
        >
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>

<script>
import {
  getImageUrl,
  getAreaByAreaId,
  goodUnsellsUrl,
  deleteOrderUrl,
  queryManagerOrderListUrl,
  confirmReceiveOrderUrl,
  transBilPc,
baseUrl
} from "@/api/api";
import { mapState } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      formInline: {
        user: "",
        region: "",
      },
      list: null,
      selectedList: null,
      loading: false,
      index: "0",
      pageIndex: 0,
      total: 0,
      currentOrder:null
    };
  },
  created() {
    this.getImageUrl = getImageUrl;
  },
  mounted() {
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    this.initData();
  },
  computed: {
    ...mapState(["userInfo"]),
    getOrderStatus() {
      // alert(this.index);
      switch (this.index) {
        case "0":
          return "";
        case "":
          return "";
        case "1":
          return "1";
        case "2":
          return "2";
        case "3":
          return "3";
        case "4":
          return "4";
        case "5":
          return "12,13";
        case "6":
          return "5";
      }
    },
  },
  methods: {
        downloaindPdf({ order_id, type }) {
      this.loading = true
     let url =transBilPc
     let data = {
        access_token: this.userInfo.access_token,
        order_id,
        type: 1,
      };


      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data:param,
        url,
      })
        .then((res) => {
          this.loading = false
          console.log(res);
          if (res.data.resultCode == 1) {
            if(!res.data.data[0]){
              this.$alert('暂无法获取该订单电子回单信息','提示')
              return 
            }
             window.open(`${baseUrl}/transbill/order/${res.data.data[0]}`, '_blank')
          } else {
            this.$alert(res.data.resultMsg, { center: true, showClose: false });
          }
        })
        .catch((err) => {
          this.loading = false
          this.$alert(JSON.stringify(err));
        });
    },
    haveGetGoods(item) {
      this.currentOrder = item
      this.$confirm("确认收货,收货后支付款将打入商家账户", { showClose: false })
        .then(() => {
          this.ensureGetGoods();
        })
        .catch(() => {});
    },
     ensureGetGoods() {
      let url = confirmReceiveOrderUrl;

      let { id } = this.currentOrder;
      let data = {
        orderId: id,
        access_token: this.userInfo.access_token
      };
      console.log("data", data);
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
             this.$message({
                message: "操作成功",
                type: "success",
              });
            this.initData();
          } else {
            this.$alert(res.data.resultMsg, { center: true, showClose: false });
          }
        })
        .catch(err => {
          err?this.$alert(JSON.stringify(err)):this.$alert('网络请求异常');
        });
    },
    checkImgAtTable(item) {
      console.log(item);
      this.$router.push({
        name: "goodsDetail",
        query: {
          goodsId: item.p_id,
          type: -1,
        },
      });
    },
    formatteStatus({ o_status, fm_status }) {
      let text = "";
      switch (o_status) {
        case 1:
          text = "等待买家付款";
          break;
        case 2:
          text = "等待卖家发货";
          break;
        case 3:
          text = "卖家已发货";
          break;
        case 4:
          text = "等待买家评价";
          break;
        case 5:
          text = "订单已完成";
          break;
        case 6:
          text = "订单已取消";
          break;
        case 7:
          text = "订单已过期";
          break;
        case 8:
          text = "订单已删除";
          break;
        case 9:
          text = "已申请退款";
          break;
        case 10:
          text = "退款成功";
          break;
        case 11:
          text = "退款失败";
          break;
        case 12:
          text = "等待商家确认金额";
          break;
        case 13:
          text = "等待补款";
          break;
        case 14:
          text = "商家同意退款";
          break;
        case 15:
          text = "商家拒绝退款";
          break;
        default:
          break;
      }
      if (fm_status == 1 && status == 1) {
        text = "等待支付定金";
      }
      return text;
    },
    renderStatusClass({ o_status, fm_status }) {
      let className = "";
      switch (o_status) {
        case 1:
          className = "blue";
          break;
        case 2:
          className = "yellow";
          break;
        case 3:
          className = "skyblue";
          break;
        case 4:
          className = "green";
          break;
        case 5:
          className = "green";
          break;
        case 6:
          className = "gray";
          break;
        case 7:
          className = "gray";
          break;
        case 8:
          className = "gray";
          break;
        case 9:
          className = "pink";
          break;
        case 10:
          className = "green";
          break;
        case 11:
          className = "red";
          break;
        case 12:
          className = "blue";
          break;
        case 13:
          className = "blue";
          break;
        case 14:
          className = "blue";
          break;
        case 15:
          className = "red";
          break;
        default:
          break;
      }
      if (fm_status == 1 && status == 1) {
        className = "等待支付定金";
      }
      return className;
    },
    toPay(row) {
      let {
        id,
        order_id,
        totalMoney,
        prepayment,
        type,
        fm_status,
        pay_flag,
        store_name,
        store_id,
      } = row;
      this.$router.push({
        name: "payPage",
        query: {
          id,
          order_id,
          totalMoney,
          prepayment,
          type,
          fm_status,
          pay_flag,
          store_name,
          store_id,
        },
      });
    },
    handleCurrentChange(e) {
      console.log(e);
      this.pageIndex = e - 1;
      setTimeout(() => {
        this.initData();
      });
    },
    formateTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    },

    handleChangeType(e) {
      console.log(e.index);
      this.index = e.index;
      setTimeout(() => {
        this.initData();
      });
    },
    ensureDeleteOrder(row) {
      this.$confirm("确认删除订单", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then(() => this.deleteOrder(row));
    },
    deleteOrder(row) {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        ids: row.id,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: deleteOrderUrl })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            that.$message({
              message: "删除成功",
              type: "success",
            });
            that.initData();
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    handleSelectionChange(e) {
      this.selectedList = e;
    },
    processData({ p_list = [], o_list = [], m_list = [] }) {
      return o_list.map((order) => ({
        ...order,
        products: p_list
          .filter((product) => product.orderId === order.id)
          .map((product) => ({
            ...product,
            items: m_list.filter((item) => item.opId === product.id),
          })),
      }));
    },
    initData() {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        store_id: this.userInfo.storeId,
        o_status: this.getOrderStatus,
        // pageNum: pageIndex,
        pageIndex: this.pageIndex,
        pageSize: 15,
        type: 2, //1作为卖家的,2作为买家的
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url: queryManagerOrderListUrl,
      })
        .then( (res)=> {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            let data1 = res.data.data;
            data1 = that.processData(data1 || {}).filter((item) => {
              return item.type != 9;
            });
            that.total = res.data.count;
            that.list = JSON.parse(JSON.stringify(data1));
            console.log("that.list", that.list);
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch( (error)=> {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      });
    },
  },
};
</script>

<style scoped lang='less'>
.headerBtn {
  margin-bottom: 10px;
  // background-color: red;
}
.container {
  margin: 10px;
}
.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}

.afterBox {
  border-bottom: 1px solid #009e96;
  display: inline;
  width: 200px;
  position: relative;
  // left:-2px;
  z-index: 10;
  background-color: #f6f6f6;
}
.tabsBox {
  display: flex;
  flex-direction: row;
}
.goodsDetailItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ecf5ff;
  margin-bottom: 10px;
  padding: 10px;
}
.goodsDetailItemImg {
  width: 60px;
  height: 60px;
}
.goodsDetailItemText {
  margin-left: 40px;
  font-size: 12px;
  color: #545454;
}
.goodsDetailBox {
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/StoreBuyOrder.vue